import { render, staticRenderFns } from "./BaseDataTable.vue?vue&type=template&id=0b87b0c6&scoped=true"
import script from "./BaseDataTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTable.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTable.vue?vue&type=style&index=0&id=0b87b0c6&prod&lang=scss&scoped=true"
import style1 from "./BaseDataTable.vue?vue&type=style&index=1&id=0b87b0c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87b0c6",
  null
  
)

export default component.exports